/**
 * Image Gallery JavaScript
 */
(function($) {
    'use strict';

    class ImageGallery {
        constructor() {
            this.container = $('.image-gallery-container');
            this.grid = $('.gallery-grid');
            this.popup = $('.gallery-popup');
            this.currentIndex = 0;
            this.currentImageIndex = 0;
            this.galleryItems = [];
            this.isPopupOpen = false;
            this.galleryData = new Map(); // Cache for gallery data
            this.preloadedImages = new Map(); // Cache for preloaded images
            
            // Pagination and filtering state
            this.currentPage = 1;
            this.currentCategory = '';
            this.hasMore = true;
            
            // Infinite scroll state
            this.isLoading = false;
            this.isLoadingMoreForPopup = false;
            this.lastScrollTop = 0; // Track scroll direction

            this.init();
        }

        init() {
            if (this.container.length === 0) return;

            // Read configuration from data attributes
            this.postsPerPage = parseInt(this.grid.data('posts-per-page')) || 10;
            this.orderby = this.grid.data('orderby') || 'menu_order';
            this.order = this.grid.data('order') || 'ASC';

            console.log('[Gallery] Initializing with', this.postsPerPage, 'posts per page');
            console.log('[Gallery] Initial items in grid:', this.grid.find('.gallery-item').length);

            this.bindEvents();
            this.collectGalleryItems();
        }

        bindEvents() {
            // Filter buttons
            this.container.on('click', '.filter-btn', (e) => {
                e.preventDefault();
                this.handleFilter($(e.currentTarget));
            });

            // Initialize infinite scroll with simple scroll handler
            this.initScrollHandler();

            // Gallery item clicks
            this.container.on('click', '.gallery-item', (e) => {
                e.preventDefault();
                this.openPopup($(e.currentTarget));
            });

            // Popup events
            this.popup.on('click', '.popup-close, .popup-overlay', (e) => {
                e.preventDefault();
                this.closePopup();
            });

            this.popup.on('click', '.popup-post-prev', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.navigatePopup(-1);
            });

            this.popup.on('click', '.popup-post-next', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.navigatePopup(1);
            });

            // General navigation buttons
            this.popup.on('click', '.popup-nav-prev', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.navigatePopup(-1);
            });

            this.popup.on('click', '.popup-nav-next', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.navigatePopup(1);
            });

            this.popup.on('click', '.popup-image-prev', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.navigateImage(-1);
            });

            this.popup.on('click', '.popup-image-next', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.navigateImage(1);
            });


            // Keyboard navigation
            $(document).on('keydown', (e) => {
                if (!this.isPopupOpen) return;

                switch(e.key) {
                    case 'Escape':
                        this.closePopup();
                        break;
                    case 'ArrowLeft':
                        this.navigatePopup(-1);
                        break;
                    case 'ArrowRight':
                        this.navigatePopup(1);
                        break;
                }
            });
        }

        collectGalleryItems() {
            // Only collect actual gallery items, not the sentinel
            this.galleryItems = this.grid.find('.gallery-item').toArray();
            console.log('[Gallery] Collected', this.galleryItems.length, 'gallery items');
            this.preloadAllGalleryData();
        }

        preloadAllGalleryData() {
            // Preload data for all gallery items
            const postIds = this.galleryItems.map(item => $(item).data('id'));

            postIds.forEach(postId => {
                if (!this.galleryData.has(postId)) {
                    this.getPostData(postId).then(response => {
                        if (response.success) {
                            this.galleryData.set(postId, response.data);
                            this.preloadImages(postId, response.data);
                        }
                    }).catch(error => {
                        // Silently handle preload errors
                    });
                }
            });
        }

        preloadImages(postId, data) {
            const images = [];

            // Add featured image
            if (data.featured_image) {
                images.push(data.featured_image);
            }

            // Add gallery images
            if (data.gallery_images && Array.isArray(data.gallery_images)) {
                data.gallery_images.forEach(image => {
                    let imageUrl = '';
                    if (typeof image === 'string') {
                        imageUrl = image;
                    } else if (image && image.url) {
                        imageUrl = image.url;
                    } else if (image && image.sizes && image.sizes.large) {
                        imageUrl = image.sizes.large;
                    }
                    if (imageUrl) {
                        images.push(imageUrl);
                    }
                });
            }

            // Preload images
            images.forEach(imageUrl => {
                if (!this.preloadedImages.has(imageUrl)) {
                    const img = new Image();
                    img.onload = () => {
                        this.preloadedImages.set(imageUrl, true);
                    };
                    img.src = imageUrl;
                }
            });
        }

        openPopup(item) {
            const index = this.galleryItems.indexOf(item[0]);
            if (index === -1) return;

            this.currentIndex = index;
            this.currentImageIndex = 0;
            this.isPopupOpen = true;

            this.updatePopupContentFast();
            this.popup.show();
            $('body').addClass('popup-open');
        }

        closePopup() {
            this.isPopupOpen = false;
            this.popup.hide();
            $('body').removeClass('popup-open');
        }

        navigatePopup(direction) {
            const newIndex = this.currentIndex + direction;

            // Check if we need to load more items when going forward
            if (direction > 0 && newIndex >= this.galleryItems.length - 2 && this.hasMore && !this.isLoadingMoreForPopup) {
                this.loadMoreForPopup().then(() => {
                    // After loading, proceed with navigation
                    if (newIndex >= 0 && newIndex < this.galleryItems.length) {
                        this.currentIndex = newIndex;
                        this.currentImageIndex = 0;
                        this.updatePopupContentFast();
                    }
                });
                return;
            }

            if (newIndex >= 0 && newIndex < this.galleryItems.length) {
                this.currentIndex = newIndex;
                this.currentImageIndex = 0;
                this.updatePopupContentFast();
            }
        }

        navigateImage(direction) {
            const currentItem = this.galleryItems[this.currentIndex];
            const $currentItem = $(currentItem);
            const hasMultipleImages = $currentItem.find('.multiple-images-indicator').length > 0;

            if (!hasMultipleImages) return;

            const postId = $currentItem.data('id');
            const data = this.galleryData.get(postId);

            if (data && data.gallery_images) {
                const images = data.gallery_images;
                const newIndex = this.currentImageIndex + direction;

                if (newIndex >= 0 && newIndex < images.length) {
                    this.currentImageIndex = newIndex;
                    this.updateImageInPopup(images[newIndex]);
                    this.updateImageNavigation(images.length);
                }
            }
        }

        updateImageInPopup(imageData) {
            const popup = this.popup;
            let imageUrl = '';

            if (typeof imageData === 'string') {
                imageUrl = imageData;
            } else if (imageData && imageData.url) {
                imageUrl = imageData.url;
            } else if (imageData && imageData.sizes && imageData.sizes.large) {
                imageUrl = imageData.sizes.large;
            }

            if (imageUrl) {
                popup.find('.popup-image').attr('src', imageUrl);
            }
        }

        updateImageNavigation(totalImages) {
            const popup = this.popup;
            const prevBtn = popup.find('.popup-image-prev');
            const nextBtn = popup.find('.popup-image-next');

            // Show/hide navigation based on current position
            if (this.currentImageIndex === 0) {
                prevBtn.hide();
            } else {
                prevBtn.show().prop('disabled', false);
            }

            if (this.currentImageIndex === totalImages - 1) {
                nextBtn.hide();
            } else {
                nextBtn.show().prop('disabled', false);
            }

            popup.find('.current-image').text(this.currentImageIndex + 1);
            popup.find('.total-images').text(totalImages);
        }



        updatePopupContentFast() {
            const currentItem = this.galleryItems[this.currentIndex];
            const $currentItem = $(currentItem);
            const postId = $currentItem.data('id');
            const data = this.galleryData.get(postId);

            if (data) {
                // Use cached data for instant loading
                this.populatePopup(data);
            } else {
                // Fallback to AJAX if data not cached yet
                this.updatePopupContent();
            }
        }

        updatePopupContent() {
            const currentItem = this.galleryItems[this.currentIndex];
            const $currentItem = $(currentItem);
            const postId = $currentItem.data('id');

            // Show loading state
            this.showLoadingState();

            // Get post data via AJAX
            this.getPostData(postId)
                .then(response => {
                    if (response.success) {
                        this.galleryData.set(postId, response.data);
                        this.populatePopup(response.data);
                    } else {
                        this.showErrorState();
                    }
                })
                .catch(error => {
                    this.showErrorState();
                });
        }

        showLoadingState() {
            const popup = this.popup;
            popup.find('.popup-image').attr('src', '');
            popup.find('.popup-title').text('Loading...');
            popup.find('.popup-content-text').html('');
            popup.find('.popup-author').text('');
            popup.find('.popup-actions').empty();
        }

        showErrorState() {
            const popup = this.popup;
            popup.find('.popup-image').attr('src', '');
            popup.find('.popup-title').text('Error loading content');
            popup.find('.popup-content-text').html('<p>Sorry, there was an error loading this gallery item.</p>');
            popup.find('.popup-author').text('');
            popup.find('.popup-actions').empty();
        }

        getPostData(postId) {
            return $.ajax({
                url: galleryAjax.ajax_url,
                type: 'POST',
                data: {
                    action: 'get_gallery_post_data',
                    post_id: postId,
                    nonce: galleryAjax.nonce
                }
            });
        }

        populatePopup(data) {
            const popup = this.popup;

            // Reset image index
            this.currentImageIndex = 0;

            // Update image - use first image from gallery or featured image
            let imageUrl = data.featured_image;
            if (data.gallery_images && data.gallery_images.length > 0) {
                const firstImage = data.gallery_images[0];
                if (typeof firstImage === 'string') {
                    imageUrl = firstImage;
                } else if (firstImage && firstImage.url) {
                    imageUrl = firstImage.url;
                } else if (firstImage && firstImage.sizes && firstImage.sizes.large) {
                    imageUrl = firstImage.sizes.large;
                }
            }

            if (imageUrl) {
                popup.find('.popup-image').attr('src', imageUrl);
                popup.find('.popup-image').attr('alt', data.title || 'Gallery Image');
            }

            // Update content - use author instead of title
            popup.find('.popup-title').text(data.author || 'Unknown Author');
            
            // Update description content - show/hide based on content
            const contentContainer = popup.find('.popup-content-text');
            if (data.content && data.content.trim() !== '') {
                contentContainer.html(data.content).show();
            } else {
                contentContainer.empty().hide();
            }
            
            popup.find('.popup-author').text(data.author ? `By ${data.author}` : '');

            // Update post navigation buttons in footer
            const prevBtn = popup.find('.popup-post-prev');
            const nextBtn = popup.find('.popup-post-next');
            
            // Update general navigation buttons
            const generalPrevBtn = popup.find('.popup-nav-prev');
            const generalNextBtn = popup.find('.popup-nav-next');

            // Hide/show navigation buttons based on availability
            const isFirst = this.currentIndex === 0;
            const isLast = this.currentIndex === this.galleryItems.length - 1;
            
            // Footer buttons
            prevBtn.prop('disabled', isFirst);
            nextBtn.prop('disabled', isLast);
            
            // General navigation buttons
            generalPrevBtn.prop('disabled', isFirst);
            generalNextBtn.prop('disabled', isLast);


            // Update image navigation buttons
            const hasMultipleImages = data.gallery_images && data.gallery_images.length > 1;
            const imagePrevBtn = popup.find('.popup-image-prev');
            const imageNextBtn = popup.find('.popup-image-next');

            if (hasMultipleImages) {
                // Show/hide image navigation based on current position
                if (this.currentImageIndex === 0) {
                    imagePrevBtn.hide();
                } else {
                    imagePrevBtn.show().prop('disabled', false);
                }

                if (this.currentImageIndex === data.gallery_images.length - 1) {
                    imageNextBtn.hide();
                } else {
                    imageNextBtn.show().prop('disabled', false);
                }
            } else {
                imagePrevBtn.hide();
                imageNextBtn.hide();
            }

            // Update CTA buttons - show/hide based on content
            const actionsContainer = popup.find('.popup-actions');
            actionsContainer.empty();

            if (data.cta_text && data.cta_text.trim() !== '' && data.cta_url && data.cta_url.trim() !== '') {
                actionsContainer.append(
                    `<a href="${data.cta_url}" class="cta-btn" target="_blank">${data.cta_text}</a>`
                ).show();
            } else {
                actionsContainer.hide();
            }

            // Update image counter - ensure minimum of 1 for total images
            let totalImages = 1; // Default to 1 (featured image)
            if (data.gallery_images && data.gallery_images.length > 0) {
                totalImages = data.gallery_images.length;
            }
            
            popup.find('.current-image').text(this.currentImageIndex + 1);
            popup.find('.total-images').text(totalImages);

        }

        navigateImage(direction) {
            const currentItem = this.galleryItems[this.currentIndex];
            const $currentItem = $(currentItem);
            const postId = $currentItem.data('id');
            const data = this.galleryData.get(postId);

            if (!data || !data.gallery_images || data.gallery_images.length <= 1) {
                return; // No multiple images to navigate
            }

            const newImageIndex = this.currentImageIndex + direction;
            
            if (newImageIndex >= 0 && newImageIndex < data.gallery_images.length) {
                this.currentImageIndex = newImageIndex;
                this.updateImageInPopup(data.gallery_images[newImageIndex]);
                this.updateImageNavigation(data.gallery_images.length);
            }
        }

        updateImageInPopup(imageData) {
            const popup = this.popup;
            let imageUrl = '';

            if (typeof imageData === 'string') {
                imageUrl = imageData;
            } else if (imageData && imageData.url) {
                imageUrl = imageData.url;
            } else if (imageData && imageData.sizes && imageData.sizes.large) {
                imageUrl = imageData.sizes.large;
            }

            if (imageUrl) {
                popup.find('.popup-image').attr('src', imageUrl);
                popup.find('.popup-image').attr('alt', 'Gallery Image');
            }
        }

        updateImageNavigation(totalImages) {
            const popup = this.popup;
            const imagePrevBtn = popup.find('.popup-image-prev');
            const imageNextBtn = popup.find('.popup-image-next');

            // Show/hide image navigation based on current position
            if (this.currentImageIndex === 0) {
                imagePrevBtn.hide();
            } else {
                imagePrevBtn.show().prop('disabled', false);
            }

            if (this.currentImageIndex === totalImages - 1) {
                imageNextBtn.hide();
            } else {
                imageNextBtn.show().prop('disabled', false);
            }

            // Update image counter
            popup.find('.current-image').text(this.currentImageIndex + 1);
            popup.find('.total-images').text(totalImages);
        }

        handleFilter(button) {
            const category = button.data('category');

            // Update active button
            this.container.find('.filter-btn').removeClass('active');
            button.addClass('active');

            // Reset pagination state
            this.currentPage = 1;
            this.currentCategory = category;
            this.hasMore = true;
            this.lastScrollTop = $(window).scrollTop(); // Reset scroll tracking for filter

            // Load filtered items
            this.loadFilteredItems(category, 1, true);
        }

        loadFilteredItems(category, page = 1, reset = false) {
            this.showLoadingIndicator();

            const data = {
                action: 'get_gallery_items',
                nonce: this.container.data('nonce'),
                category: category,
                page: page,
                posts_per_page: this.postsPerPage,
                orderby: this.orderby,
                order: this.order
            };

            $.ajax({
                url: galleryAjax.ajax_url,
                type: 'POST',
                data: data,
                success: (response) => {
                    if (response.success) {
                        // Parse and count the actual gallery items in the response
                        const $tempDiv = $('<div>').html(response.data.html);
                        const loadedItemsCount = $tempDiv.find('.gallery-item').length;
                        console.log('[Gallery] Loaded', loadedItemsCount, 'items for page', page, '- Reset:', reset);
                        
                        if (reset) {
                            // Replace content for filtering
                            this.grid.html(response.data.html);
                            this.updateLoadMoreButton(response.data.has_more);
                            // Reset page to 1 when filtering
                            this.currentPage = 1;
                        } else {
                            // Append content for load more
                            this.grid.append(response.data.html);
                            this.updateLoadMoreButton(response.data.has_more);
                            // Update current page to confirm successful load
                            this.currentPage = page;
                        }
                        this.collectGalleryItems();
                        console.log('[Gallery] Total items in grid now:', this.grid.find('.gallery-item').length);
                        this.hasMore = response.data.has_more;
                        
                        // Check scroll position again after items are loaded
                        // This ensures we continue loading if still in trigger zone
                        setTimeout(() => {
                            this.checkScrollPosition();
                        }, 200);
                    }
                },
                error: (xhr, status, error) => {
                    // Handle AJAX error silently
                },
                complete: () => {
                    this.hideLoadingIndicator();
                    this.isLoading = false; // Reset loading state
                }
            });
        }

        loadMoreItems() {
            // Prevent duplicate loading
            if (!this.hasMore || this.isLoading) {
                console.log('[Gallery] Load more skipped - hasMore:', this.hasMore, 'isLoading:', this.isLoading);
                return;
            }

            console.log('[Gallery] Loading more items - Page:', this.currentPage + 1, 'Category:', this.currentCategory);
            this.isLoading = true;
            // Pass next page number, let loadFilteredItems update currentPage after success
            this.loadFilteredItems(this.currentCategory, this.currentPage + 1, false);
        }

        loadMoreForPopup() {
            if (this.isLoadingMoreForPopup || !this.hasMore) {
                return Promise.resolve();
            }

            this.isLoadingMoreForPopup = true;
            this.showPopupLoadingIndicator();

            const data = {
                action: 'get_gallery_items',
                nonce: this.container.data('nonce'),
                category: this.currentCategory,
                page: this.currentPage + 1,
                posts_per_page: this.postsPerPage,
                orderby: this.orderby,
                order: this.order
            };

            return new Promise((resolve, reject) => {
                $.ajax({
                    url: galleryAjax.ajax_url,
                    type: 'POST',
                    data: data
                }).done((response) => {
                    if (response.success) {
                        // Append new items to grid (hidden, just for data)
                        this.grid.append(response.data.html);
                        this.collectGalleryItems();
                        this.hasMore = response.data.has_more;
                        this.currentPage++;
                        
                        // Recreate scroll sentinel for continued infinite scroll
                        this.createScrollSentinel();
                    }
                    resolve(response);
                }).fail((xhr, status, error) => {
                    reject(error);
                }).always(() => {
                    this.isLoadingMoreForPopup = false;
                    this.hidePopupLoadingIndicator();
                });
            });
        }

        updateLoadMoreButton(hasMore) {
            // Remove load more button since we're using infinite scroll
            const loadMoreContainer = this.container.find('.gallery-load-more');
            loadMoreContainer.remove();
        }

        showLoadingIndicator() {
            this.hideLoadingIndicator();
            const loadingHtml = '<div class="gallery-loading-indicator"><div class="loading-spinner"></div><p class="loading-text">Loading more images...</p></div>';
            this.grid.append(loadingHtml);
        }

        hideLoadingIndicator() {
            this.grid.find('.gallery-loading-indicator').remove();
        }

        showPopupLoadingIndicator() {
            const nextBtn = this.popup.find('.popup-post-next');
            const generalNextBtn = this.popup.find('.popup-nav-next');
            
            nextBtn.addClass('loading').prop('disabled', true);
            nextBtn.find('span').text('Loading...');
            
            generalNextBtn.addClass('loading').prop('disabled', true);
        }

        hidePopupLoadingIndicator() {
            const nextBtn = this.popup.find('.popup-post-next');
            const generalNextBtn = this.popup.find('.popup-nav-next');
            
            nextBtn.removeClass('loading').prop('disabled', false);
            nextBtn.find('span').text('Next');
            
            generalNextBtn.removeClass('loading').prop('disabled', false);
        }

        initScrollHandler() {
            // Simple scroll event handler - works reliably everywhere
            console.log('[Gallery] Setting up scroll handler for infinite scroll');
            
            let scrollTimeout;
            
            $(window).on('scroll.galleryInfinite', () => {
                // Debounce scroll events for better performance
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(() => {
                    this.checkScrollPosition();
                }, 100);
            });
        }

        checkScrollPosition() {
            // Don't check if already loading or no more items
            if (this.isLoading || !this.hasMore) {
                return;
            }

            // Get current scroll position
            const scrollTop = $(window).scrollTop();
            
            // Check scroll direction - only trigger when scrolling DOWN
            const isScrollingDown = scrollTop > this.lastScrollTop;
            const wasScrollingDown = isScrollingDown;
            this.lastScrollTop = scrollTop;
            
            if (!isScrollingDown) {
                return; // Don't trigger when scrolling up
            }

            // Get the gallery grid position and height
            const gridTop = this.grid.offset().top;
            const gridHeight = this.grid.outerHeight();
            const gridBottom = gridTop + gridHeight;
            
            // Get viewport center position
            const windowHeight = $(window).height();
            const viewportCenter = scrollTop + (windowHeight / 2);
            
            // Calculate distance from viewport center to grid bottom
            const distanceFromGridEnd = gridBottom - viewportCenter;
            
            
            // Trigger when viewport center is within 600px BEFORE the end of the grid
            // Allow up to 300px past the grid end (for cases where user scrolls quickly)
            if (distanceFromGridEnd < 600 && distanceFromGridEnd > -300) {
                this.loadMoreItems();
            }
        }

        destroyScrollHandler() {
            // Clean up scroll handler
            $(window).off('scroll.galleryInfinite');
            console.log('[Gallery] Scroll handler removed');
        }

    }

    // Initialize when document is ready
    $(document).ready(function() {
        // Only initialize if gallery container exists and hasn't been initialized
        if ($('.image-gallery-container').length > 0 && !$('.image-gallery-container').data('gallery-initialized')) {
            $('.image-gallery-container').data('gallery-initialized', true);
            new ImageGallery();
        }
    });

    // Add CSS for popup open state
    $('<style>')
        .prop('type', 'text/css')
        .html(`
            body.popup-open {
                overflow: hidden;
            }
        `)
        .appendTo('head');

})(jQuery);